import { useState } from "react";
import {
  Button,
  Dropdown,
  Grid,
  Icon,
  Input,
  Label,
  Loader,
  Menu,
  MenuItem,
  Modal,
  Segment,
  Table,
} from "semantic-ui-react";
import LograrSegurosService from "../../../../services/LograrSeguros";

const TIPO_DOC_OPTIONS = [
  { key: "DNI", value: "DNI", text: "DNI" },
  { key: "CUIT", value: "CUIT", text: "CUIT" },
];

const COBERTURA_COLORS = {
  HABILITADO: "green",
  PARCIALMENTE_HABILITADO: "yellow",
  NO_HABILITADO: "red",
  SIN_POLIZAS_ACTIVAS: "grey",
};

const COBERTURA_LABELS = {
  HABILITADO: "Habilitado",
  PARCIALMENTE_HABILITADO: "Parcialmente habilitado",
  NO_HABILITADO: "No habilitado",
  SIN_POLIZAS_ACTIVAS: "Sin pólizas activas",
};

const BeneficiariosLograr = () => {
  const [modoActivo, setModoActivo] = useState("documento");

  const [tipoDoc, setTipoDoc] = useState("DNI");
  const [nroDoc, setNroDoc] = useState("");
  const [apellido, setApellido] = useState("");

  const [resultados, setResultados] = useState(null);
  const [loadingBusqueda, setLoadingBusqueda] = useState(false);
  const [errorBusqueda, setErrorBusqueda] = useState(null);

  const [loadingCobertura, setLoadingCobertura] = useState(null);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [modalData, setModalData] = useState(null);

  const puedesBuscarDocumento = tipoDoc && nroDoc.trim() !== "";
  const puedesBuscarApellido = apellido.trim() !== "";

  const handleModoClick = (modo) => {
    setModoActivo(modo);
    setResultados(null);
    setErrorBusqueda(null);
    setNroDoc("");
    setApellido("");
  };

  const buscar = async () => {
    setLoadingBusqueda(true);
    setErrorBusqueda(null);
    setResultados(null);
    try {
      const params =
        modoActivo === "documento"
          ? { tipoDoc, nroDoc: nroDoc.trim() }
          : { apellido: apellido.trim() };

      const respuesta = await LograrSegurosService.buscarIndividuo(params);

      if (!respuesta.success || !respuesta.data || respuesta.data.length === 0) {
        setResultados([]);
      } else {
        setResultados(respuesta.data);
      }
    } catch (err) {
      setErrorBusqueda("Error al realizar la búsqueda. Intente nuevamente.");
    } finally {
      setLoadingBusqueda(false);
    }
  };

  const verDetalles = async (individuo) => {
    const { code, tipoDocumento, nroDocumento } = individuo;
    setLoadingCobertura(code);
    try {
      const respuesta = await LograrSegurosService.consultarCobertura(
        tipoDocumento,
        nroDocumento
      );
      setModalData(respuesta);
      setModalAbierto(true);
    } catch {
      // no-op
    } finally {
      setLoadingCobertura(null);
    }
  };

  const formatFecha = (isoDate) => {
    if (!isoDate) return "-";
    try {
      return new Date(isoDate).toLocaleDateString("es-AR");
    } catch {
      return isoDate;
    }
  };

  return (
    <>
      <h1>Beneficiarios Lograr Seguros</h1>

      <Segment>
        <h3>Buscador</h3>
        <Menu tabular>
          <MenuItem
            name="Por Documento"
            active={modoActivo === "documento"}
            onClick={() => handleModoClick("documento")}
          />
          <MenuItem
            name="Por Apellido"
            active={modoActivo === "apellido"}
            onClick={() => handleModoClick("apellido")}
          />
        </Menu>

        <Segment attached="bottom" style={{ overflow: "visible", minHeight: "110px" }}>
          {modoActivo === "documento" ? (
            <Grid>
              <Grid.Row>
                <Grid.Column mobile={16} tablet={8} computer={3}>
                  <label>Tipo de documento</label>
                  <br />
                  <Dropdown
                    selection
                    options={TIPO_DOC_OPTIONS}
                    value={tipoDoc}
                    onChange={(_, { value }) => setTipoDoc(value)}
                    style={{ marginTop: "5px", minWidth: "160px" }}
                  />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={8} computer={6}>
                  <label>Número de documento</label>
                  <br />
                  <Input
                    style={{ marginTop: "5px", marginRight: "10px" }}
                    placeholder="Ej: 22360415"
                    value={nroDoc}
                    onChange={(e) => setNroDoc(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && puedesBuscarDocumento && !loadingBusqueda && buscar()}
                  />
                  <Button
                    style={{ minWidth: "100px" }}
                    disabled={loadingBusqueda || !puedesBuscarDocumento}
                    onClick={buscar}
                  >
                    {loadingBusqueda ? <Loader active inline size="mini" /> : "Buscar"}
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          ) : (
            <Grid>
              <Grid.Row>
                <Grid.Column mobile={16} tablet={8} computer={6}>
                  <label>Apellido</label>
                  <br />
                  <Input
                    style={{ marginTop: "5px", marginRight: "10px" }}
                    placeholder="Ej: Salemme"
                    value={apellido}
                    onChange={(e) => setApellido(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && puedesBuscarApellido && !loadingBusqueda && buscar()}
                  />
                  <Button
                    style={{ minWidth: "100px" }}
                    disabled={loadingBusqueda || !puedesBuscarApellido}
                    onClick={buscar}
                  >
                    {loadingBusqueda ? <Loader active inline size="mini" /> : "Buscar"}
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          )}
        </Segment>
      </Segment>

      {errorBusqueda && (
        <Segment style={{ marginTop: "30px" }}>
          <p style={{ color: "red" }}>{errorBusqueda}</p>
        </Segment>
      )}

      {resultados !== null && (
        <Segment style={{ marginTop: "30px" }}>
          {resultados.length === 0 ? (
            <p>No se encontraron beneficiarios.</p>
          ) : (
            <>
              <h3>Resultados ({resultados.length})</h3>
              <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: "45vh" }}>
                <Table celled striped>
                  <Table.Header style={{ position: "sticky", top: 0, zIndex: 1 }}>
                    <Table.Row>
                      <Table.HeaderCell>Código</Table.HeaderCell>
                      <Table.HeaderCell>Nombre</Table.HeaderCell>
                      <Table.HeaderCell>Apellido</Table.HeaderCell>
                      <Table.HeaderCell>Tipo Doc.</Table.HeaderCell>
                      <Table.HeaderCell>Nro. Documento</Table.HeaderCell>
                      <Table.HeaderCell>Fecha Alta</Table.HeaderCell>
                      <Table.HeaderCell>Cobertura</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {resultados.map((individuo) => (
                      <Table.Row key={individuo.code}>
                        <Table.Cell>{individuo.code}</Table.Cell>
                        <Table.Cell>{individuo.firstName}</Table.Cell>
                        <Table.Cell>{individuo.lastName}</Table.Cell>
                        <Table.Cell>{individuo.tipoDocumentoNombre}</Table.Cell>
                        <Table.Cell>{individuo.nroDocumento}</Table.Cell>
                        <Table.Cell>{formatFecha(individuo.activeDate)}</Table.Cell>
                        <Table.Cell>
                          {loadingCobertura === individuo.code ? (
                            <Loader active inline size="mini" />
                          ) : (
                            <Button
                              size="mini"
                              color="blue"
                              onClick={() => verDetalles(individuo)}
                              disabled={loadingCobertura !== null}
                            >
                              Detalles
                            </Button>
                          )}
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </div>
            </>
          )}
        </Segment>
      )}
      {modalAbierto && modalData && (
        <Modal open={modalAbierto} onClose={() => setModalAbierto(false)} size="large">
          <Modal.Header>
            Detalles de cobertura{" "}
            <Label
              color={COBERTURA_COLORS[modalData.estadoCobertura] || "grey"}
              size="small"
            >
              {COBERTURA_LABELS[modalData.estadoCobertura] || modalData.estadoCobertura}
            </Label>
          </Modal.Header>
          <Modal.Content scrolling>
            {modalData.asegurado && (
              <Segment secondary style={{ marginBottom: "16px" }}>
                <strong>Asegurado:</strong>{" "}
                {modalData.asegurado.nombre} {modalData.asegurado.apellido} &mdash;{" "}
                {modalData.asegurado.tipoDocumento} {modalData.asegurado.nroDocumento}
              </Segment>
            )}
            {modalData.polizas && modalData.polizas.length > 0 ? (
              modalData.polizas.map((poliza) => (
                <Segment key={poliza.policyCode} style={{ marginBottom: "12px" }}>
                  <h4 style={{ marginTop: 0, marginBottom: "10px" }}>
                    Póliza {poliza.policyNumber}{" "}
                    <span style={{ fontWeight: "normal", color: "#666" }}>{poliza.alias}</span>
                  </h4>
                  <Table definition compact size="small" style={{ marginBottom: "12px" }}>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>Vigencia</Table.Cell>
                        <Table.Cell>
                          {formatFecha(poliza.vigenciaDesde)} &mdash; {formatFecha(poliza.vigenciaHasta)}
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>Habilitado para prestación</Table.Cell>
                        <Table.Cell>
                          <Label
                            color={poliza.habilitadoParaPrestacion ? "green" : "red"}
                            size="mini"
                          >
                            {poliza.habilitadoParaPrestacion ? "Sí" : "No"}
                          </Label>
                        </Table.Cell>
                      </Table.Row>
                      {poliza.motivoDeshabilitacion && (
                        <Table.Row>
                          <Table.Cell>Motivo deshabilitación</Table.Cell>
                          <Table.Cell>{poliza.motivoDeshabilitacion}</Table.Cell>
                        </Table.Row>
                      )}
                    </Table.Body>
                  </Table>
                  {poliza.coberturas && poliza.coberturas.length > 0 && (
                    <>
                      <strong>Coberturas</strong>
                      <Table celled compact size="small" style={{ marginTop: "6px" }}>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell>Cobertura</Table.HeaderCell>
                            <Table.HeaderCell>Tipo</Table.HeaderCell>
                            <Table.HeaderCell>Suma asegurada</Table.HeaderCell>
                            <Table.HeaderCell>Fecha inclusión</Table.HeaderCell>
                            <Table.HeaderCell>Fecha exclusión</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {poliza.coberturas.map((cobertura, idx) => (
                            <Table.Row key={idx}>
                              <Table.Cell>{cobertura.nombre}</Table.Cell>
                              <Table.Cell>{cobertura.tipo}</Table.Cell>
                              <Table.Cell>
                                {cobertura.sumaAsegurada != null
                                  ? `$${Number(cobertura.sumaAsegurada).toLocaleString("es-AR")}`
                                  : "-"}
                              </Table.Cell>
                              <Table.Cell>{formatFecha(cobertura.inclusionDate)}</Table.Cell>
                              <Table.Cell>{formatFecha(cobertura.exclusionDate)}</Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </>
                  )}
                </Segment>
              ))
            ) : (
              <p>Sin pólizas activas.</p>
            )}
          </Modal.Content>
          <Modal.Actions>
            <Button color="grey" onClick={() => setModalAbierto(false)}>
              <Icon name="close" /> Cerrar
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </>
  );
};

export default BeneficiariosLograr;
